import type { Flag, SubscriptionStateName } from './types'

/** Plain-language names for the reasons a team is flagged. */
export const flagLabels: Record<Flag, { label: string; hint: string; tone: 'risk' | 'warn' | 'quiet' }> = {
  payment_issue: { label: 'Payment issue', hint: 'An invoice is unpaid after a failed attempt, or was written off.', tone: 'risk' },
  subscription_expired: { label: 'Subscription ended', hint: 'The paid period is over and Stripe has not renewed it.', tone: 'risk' },
  over_company_limit: { label: 'Over company limit', hint: 'More companies than the plan allows.', tone: 'risk' },
  over_user_limit: { label: 'Over user limit', hint: 'More members than the plan allows.', tone: 'risk' },
  sync_error: { label: 'HubSpot sync failed', hint: 'The last HubSpot sync ended in an error.', tone: 'risk' },
  subscription_expiring: { label: 'Renews soon', hint: 'The paid period ends within 14 days.', tone: 'warn' },
  cancel_pending: { label: 'Cancelling', hint: 'The subscription ends at the end of the paid period.', tone: 'warn' },
  near_company_limit: { label: 'Near company limit', hint: '90% or more of the companies the plan allows.', tone: 'warn' },
  near_user_limit: { label: 'Near user limit', hint: '90% or more of the members the plan allows.', tone: 'warn' },
  inactive_30d: { label: 'Quiet for 30 days', hint: 'No new data and no member sign-in for 30 days.', tone: 'quiet' },
  no_members: { label: 'No members', hint: 'Nobody belongs to this team.', tone: 'quiet' },
}

export const stateLabels: Record<SubscriptionStateName, string> = {
  free: 'Free',
  active: 'Active',
  expiring: 'Renews soon',
  canceling: 'Cancelling',
  expired: 'Ended',
}

export const statusLabels: Record<string, string> = {
  customer: 'Customer',
  lead: 'Lead',
  opportunity: 'Opportunity',
  churned: 'Churned',
  lost_lead: 'Lost lead',
  lost_opportunity: 'Lost opportunity',
}

export const sourceLabels: Record<string, string> = {
  hubspot: 'HubSpot',
  zapier: 'Zapier',
  importXls: 'Spreadsheet import',
  manual: 'Added by hand',
}

export const providerLabels: Record<string, string> = {
  password: 'Email',
  'google.com': 'Google',
}

export const syncLabels: Record<string, string> = {
  success: 'Synced',
  in_progress: 'Syncing',
  error: 'Failed',
  not_started: 'Not started',
}
